import {
  Mousewheel,
  core_default
} from "./chunk.VVD5NVY2.js";
import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  Linkable
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-carousel/jb-carousel.scss?inline
var jb_carousel_default = i`/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */
@font-face {
  font-family: "swiper-icons";
  src: url("data:application/font-woff;charset=utf-8;base64, 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") format("woff");
  font-weight: 400;
  font-style: normal;
}
:root {
  --swiper-theme-color: #007aff;
}

.swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
}

.swiper-vertical > .swiper-wrapper {
  flex-direction: column;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.swiper-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-pointer-events {
  touch-action: pan-y;
}
.swiper-pointer-events.swiper-vertical {
  touch-action: pan-x;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.swiper-slide-invisible-blank {
  visibility: hidden;
}

/* Auto Height */
.swiper-autoheight,
.swiper-autoheight .swiper-slide {
  height: auto;
}
.swiper-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

.swiper-backface-hidden .swiper-slide {
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* 3D Effects */
.swiper-3d, .swiper-3d.swiper-css-mode .swiper-wrapper {
  perspective: 1200px;
}
.swiper-3d .swiper-wrapper,
.swiper-3d .swiper-slide,
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}
.swiper-3d .swiper-slide-shadow {
  background: rgba(0, 0, 0, 0.15);
}
.swiper-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

/* CSS Mode */
.swiper-css-mode > .swiper-wrapper {
  overflow: auto;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}
.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {
  display: none;
}
.swiper-css-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: start start;
}

.swiper-horizontal.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: x mandatory;
}

.swiper-vertical.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: y mandatory;
}

.swiper-centered > .swiper-wrapper::before {
  content: "";
  flex-shrink: 0;
  order: 9999;
}
.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {
  margin-inline-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-horizontal > .swiper-wrapper::before {
  height: 100%;
  width: var(--swiper-centered-offset-after);
}
.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {
  margin-block-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-vertical > .swiper-wrapper::before {
  width: 100%;
  height: var(--swiper-centered-offset-after);
}
.swiper-centered > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: center center;
  scroll-snap-stop: always;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.intro-section p {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.intro-section p {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.063rem;
  line-height: 1.875rem;
}
@media (min-width: 1281px) {
  .intro-section p {
    font-size: 1.188rem;
    line-height: 2.125rem;
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
.intro-section {
  --_grid-gap: 16px;
  --_grid-template-columns: repeat(12, 1fr);
  display: grid;
  gap: var(--grid-row-gap, 0) var(--grid-column-gap, var(--_grid-gap));
  grid-template-columns: var(--theme-grid-template-columns, var(--_grid-template-columns));
  width: 100%;
}
@media (min-width: 960px) {
  .intro-section {
    --_grid-gap: 40px;
  }
}

section {
  --_max-width: calc(100% - (2 * 6.68%));
  display: grid;
  grid-template-columns: [full-start] minmax(0, 1fr) [main-start] minmax(0, var(--theme-grid-max-width, var(--_max-width))) [main-end] minmax(0, 1fr) [full-end];
  margin-inline: auto;
}
@media (min-width: 600px) {
  section {
    --_max-width: calc(100% - (2 * 8.35%));
  }
}
@media (min-width: 960px) {
  section {
    --_max-width: calc(100% - (2 * 6.955%));
  }
}
@media (min-width: 1437px) {
  section {
    --_max-width: 1437px;
  }
}

:host {
  color: var(--host-color, #141e55);
}

section {
  padding-block: var(--spacing-2xl);
}
section.smoke-light {
  background: #f1f2f2;
}
section.stone {
  background: #b0aa7e;
}
section.stone-light {
  background: #f7f7f2;
}
section.violet-light {
  background: #f2eff0;
}

.intro-section {
  grid-column: main;
  grid-template-columns: subgrid;
  justify-content: center;
  --flex: 1;
}
@media (min-width: 1281px) {
  .intro-section {
    grid-template-columns: var(--_grid-template-columns);
  }
  .intro-section > * {
    grid-column: 3/span 8;
  }
}
.intro-section jb-section-headline {
  justify-content: center;
  margin-block-start: 0;
}
.intro-section p {
  color: rgba(20, 30, 85, var(--theme-opacity-80, 0.8));
  justify-content: center;
  margin-block-start: var(--spacing-xs);
  text-align: center;
}
@media (min-width: 1281px) {
  .intro-section p {
    margin-block-start: var(--spacing-s);
  }
}
.intro-section.left-aligned p {
  text-align: start;
}

.wrapper {
  display: grid;
  grid-column: full;
  grid-template-columns: subgrid;
  margin-block-start: var(--spacing-l);
  overflow: hidden;
  width: 100%;
}
@media (min-width: 1437px) {
  .wrapper {
    margin-block-start: var(--spacing-xl);
  }
}

.swiper {
  grid-column: main;
  overflow: visible;
  width: 100%;
}
@media (min-width: 600px) {
  .swiper {
    padding-inline-end: unset;
  }
}

.swiper-slide {
  transition: opacity 0.2s ease-in-out;
  width: calc((100% - 5 * var(--spacing-gap)) / 6 * 5 + 4 * var(--spacing-gap));
}
.swiper-slide.swiper-slide-visible {
  opacity: 1;
}
.swiper-slide__title {
  margin-block-end: 0;
}
.swiper-slide:hover {
  --transform-tag: scale(1.05);
}
.swiper-slide:last-of-type {
  margin-inline-end: 0 !important;
}
@media (min-width: 960px) {
  .swiper-slide {
    opacity: 0.4;
  }
}

.arrows-wrapper {
  display: flex;
  grid-column: main;
  inline-size: 100%;
  justify-content: center;
  margin-block-start: var(--spacing-s);
}
@media (min-width: 1281px) {
  .arrows-wrapper {
    justify-content: right;
  }
}

jb-arrow-navigation {
  display: flex;
}
jb-arrow-navigation[carousel-items="1"] {
  display: none;
}
jb-arrow-navigation[carousel-items="2"] {
  display: flex;
}
@media (min-width: 600px) {
  jb-arrow-navigation[carousel-items="2"] {
    display: none;
  }
}
jb-arrow-navigation[carousel-items="3"] {
  display: flex;
}
@media (min-width: 960px) {
  jb-arrow-navigation[carousel-items="3"] {
    display: none;
  }
}
jb-arrow-navigation[carousel-items="4"][carousel-with-publications=true] {
  display: flex;
}
@media (min-width: 960px) {
  jb-arrow-navigation[carousel-items="4"][carousel-with-publications=true] {
    display: none;
  }
}

jb-button-panel {
  grid-column: main;
  justify-content: center;
  margin-block-start: var(--spacing-s);
  padding: 0;
  --white-space: nowrap;
  --panel-gap: var(--_grid-gap);
}
jb-button-panel jb-button-secondary {
  inline-size: 100%;
}
@media (min-width: 1281px) {
  jb-button-panel jb-button-secondary {
    flex: var(--flex, 0 1 auto);
    inline-size: unset;
  }
}

.publications .swiper-slide {
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  transition: transform 0.3s, opacity 0.5s;
}
.publications .swiper-slide.swiper-slide-visible:hover {
  transform: scale(1.05);
}`;

// src/components/jb-carousel/jb-carousel.ts
var JbCarousel = class extends Spaceable(Linkable(h)) {
  constructor() {
    super(...arguments);
    this._nextDisabled = false;
    this._previousDisabled = false;
  }
  firstUpdated() {
    this._arrow_navigation.setAttribute("carousel-items", this._slottedChildren.length.toString());
    if (this.publications) {
      this._arrow_navigation.setAttribute("carousel-with-publications", "true");
    }
    this._slottedChildren.forEach((slottedChild) => {
      slottedChild.classList.add("swiper-slide");
      slottedChild.setAttribute("gallery", "");
      this._swiper_wrapper.appendChild(slottedChild);
    });
    const defaultOptions = {
      breakpoints: {
        // xs
        0: {
          centeredSlides: true,
          slidesPerView: "auto",
          spaceBetween: 16
        },
        // sm
        600: {
          centeredSlides: false,
          slidesPerView: 2,
          spaceBetween: 16
        },
        // md
        960: {
          centeredSlides: false,
          slidesPerView: 2,
          spaceBetween: 40
        },
        // lg+
        1281: {
          centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 40
        }
      },
      centerInsufficientSlides: true,
      centeredSlidesBounds: true,
      loopFillGroupBlank: false,
      modules: [Mousewheel],
      mousewheel: {
        forceToAxis: true
      },
      slideToClickedSlide: true,
      spaceBetween: 16,
      watchSlidesProgress: true
    };
    const publicationOptions = {
      ...defaultOptions,
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        // md
        960: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      },
      centeredSlides: false
    };
    this._swiper = new core_default(this._swiper_element, this.publications ? publicationOptions : defaultOptions);
    this._swiper.on("slideChange", this._slideChanged.bind(this));
    this._slideChanged();
    window.addEventListener("resize", this._slideChanged.bind(this));
  }
  nextSlide() {
    this._swiper.slideNext();
  }
  previousSlide() {
    this._swiper.slidePrev();
  }
  _getContentSpacingProperties() {
    return { grid: true, horizontal: "full-width", colsMdUp: "none", type: "no-vertical-space" };
  }
  _slideChanged() {
    this._nextDisabled = this._swiper.isEnd;
    this._previousDisabled = this._swiper.isBeginning;
  }
  get _slottedChildren() {
    return this._slot.assignedElements({ flatten: true });
  }
  render() {
    return ke`<section
      class="${Rt({
      "smoke-light": this.backgroundColor === "smoke-light",
      stone: this.backgroundColor === "stone",
      "stone-light": this.backgroundColor === "stone-light",
      "violet-light": this.backgroundColor === "violet-light",
      publications: this.publications
    })}"
    >
      <div class="intro-section ${this.buttons ? " left-aligned" : ""}">
        <jb-section-headline .headline=${this.headline}></jb-section-headline>
        ${this.text ? ke`<p>${this.text}</p>` : D}
        ${this.buttons ? ke`
              <jb-button-panel align="center">
                ${this.buttons.map(
      (button) => ke`<jb-button-secondary .link=${button.link}>
                      ${button.icon === "spotify" ? ke`<svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M14.6607 17.2905C14.6214 18.8048 14.4608 20.3009 13.9705 21.7465C13.7406 22.4245 13.4327 23.0649 12.8878 23.5649C12.2551 24.1447 11.7315 24.1502 11.0952 23.5504C10.4197 22.9126 10.0981 22.0766 9.86429 21.2162C9.41376 19.5582 9.29117 17.8548 9.32281 16.1475C9.34917 14.7211 10.5692 13.5848 11.9854 13.5763C13.3702 13.568 14.5323 14.6175 14.6541 16.0133C14.6918 16.4359 14.6607 16.8654 14.6607 17.2905Z"
                              fill="#141E55"
                            />
                            <path
                              d="M9.30423 10.1752C9.29711 8.67731 10.5667 7.46306 12.125 7.47886C13.4813 7.49259 14.7009 8.74052 14.7148 10.1289C14.7293 11.5815 13.4874 12.8084 11.9995 12.8118C10.5303 12.8151 9.31214 11.6224 9.30423 10.1752Z"
                              fill="#141E55"
                            />
                            <path
                              d="M23.0954 9.72395C22.5381 4.08714 17.3624 -0.244225 11.4775 0.0106987C5.66934 0.262254 0.98396 5.09103 1.00004 10.8659C1.01612 16.6082 5.33981 20.3673 8.60189 21.168C8.49943 20.6787 8.41375 20.1875 8.34486 19.6942C8.21595 19.5299 8.02851 19.3986 7.77042 19.2771C4.11581 17.5522 1.95805 13.4325 2.59602 9.51177C3.47336 4.12056 8.55391 0.660183 14.0444 1.71381C19.125 2.68895 22.5671 7.88275 21.4145 12.8408C20.7004 15.9131 18.8837 18.1211 16.001 19.4921C15.8892 19.5452 15.7482 19.5628 15.666 19.6592C15.5953 20.1932 15.5057 20.7242 15.3923 21.2517C19.1526 20.3069 23.7244 16.0605 23.0954 9.72395Z"
                              fill="#141E55"
                            />
                            <path
                              d="M19.0481 9.33432C18.2309 5.98456 15.1489 3.74103 11.5544 3.84725C8.28544 3.94414 5.36449 6.47135 4.75684 9.71049C4.11544 13.1302 6.21784 16.1095 8.10882 16.9952C8.08535 16.3944 8.07876 15.7924 8.08588 15.1898C8.05424 15.144 8.01794 15.1016 7.97753 15.0631C6.8885 14.01 6.32066 12.7294 6.21732 11.2289C5.96872 7.62395 9.55532 4.5856 13.1374 5.39026C15.364 5.89026 16.8941 7.19182 17.5326 9.35219C18.1821 11.5491 17.6175 13.4854 15.9508 15.0983C15.9366 15.1117 15.9218 15.1245 15.9063 15.1364C15.92 15.6224 15.8928 16.1118 15.8928 16.5989C15.8893 16.732 15.8852 16.865 15.8804 16.9978C18.0706 15.8307 19.8638 12.6766 19.0481 9.33432Z"
                              fill="#141E55"
                            />
                          </svg>` : D}
                      ${button.icon === "apple" ? ke`<svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              id="Spotify"
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M0 12.0001C0 5.37268 5.37269 0 11.9999 0L11.9998 0.000573192C18.6279 0.000573192 24 5.37311 24 12.0001C24 18.6278 18.6279 24 11.9999 24C5.37269 24 0 18.6278 0 12.0001ZM16.4742 17.5555C16.8267 17.7718 17.2881 17.6601 17.503 17.3075C17.7194 16.955 17.6076 16.495 17.2551 16.2787C14.092 14.3456 10.1711 13.8955 5.59996 14.9403C5.19644 15.032 4.94524 15.4332 5.03738 15.8359C5.12909 16.2385 5.53032 16.4907 5.93283 16.399C10.1099 15.4447 13.6567 15.8344 16.4742 17.5555ZM18.9718 14.0396C18.701 14.4803 18.1249 14.6193 17.685 14.3484C14.4594 12.3653 9.54257 11.7911 5.72735 12.9493C5.23255 13.0987 4.70995 12.8199 4.55978 12.3259C4.41075 11.8311 4.68975 11.3095 5.18369 11.1591C9.54171 9.8367 14.9595 10.4772 18.6637 12.7535C19.1036 13.0244 19.2426 13.6004 18.9718 14.0398V14.0396ZM5.15689 9.24946C8.84945 8.12873 15.2304 8.33995 19.0979 10.6372H19.0985C19.6301 10.9539 20.3208 10.778 20.636 10.2447C20.9527 9.71203 20.7779 9.0232 20.2434 8.70665C15.7906 6.06323 8.74413 5.81461 4.50533 7.10143C3.91195 7.28169 3.5775 7.90834 3.75719 8.50159C3.93688 9.09456 4.56394 9.4293 5.15689 9.24946Z"
                              fill="#141E55"
                            />
                          </svg> ` : D}
                      ${button.text}
                    </jb-button-secondary>`
    )}
              </jb-button-panel>
            ` : D}
      </div>
      <div class="wrapper">
        <div class="swiper">
          <div class="swiper-wrapper"></div>
        </div>
      </div>
      <div class="arrows-wrapper">
        <jb-arrow-navigation
          @jb-arrow-navigation:next-clicked=${this.nextSlide}
          @jb-arrow-navigation:prev-clicked=${this.previousSlide}
          .nextDisabled=${this._nextDisabled}
          .prevDisabled=${this._previousDisabled}
        ></jb-arrow-navigation>
      </div>
      <slot></slot>
      ${this.buttonText ? ke`
            <jb-button-panel align="center">
              <jb-button-secondary .link="${this.link}">${this.buttonText} </jb-button-secondary>
            </jb-button-panel>
          ` : D}
    </section>`;
  }
};
JbCarousel.styles = r(jb_carousel_default);
__decorateClass([
  n()
], JbCarousel.prototype, "backgroundColor", 2);
__decorateClass([
  n({ type: Array })
], JbCarousel.prototype, "buttons", 2);
__decorateClass([
  n()
], JbCarousel.prototype, "buttonText", 2);
__decorateClass([
  n()
], JbCarousel.prototype, "headline", 2);
__decorateClass([
  n({ type: Boolean })
], JbCarousel.prototype, "publications", 2);
__decorateClass([
  n()
], JbCarousel.prototype, "text", 2);
__decorateClass([
  e("jb-arrow-navigation")
], JbCarousel.prototype, "_arrow_navigation", 2);
__decorateClass([
  r2()
], JbCarousel.prototype, "_nextDisabled", 2);
__decorateClass([
  r2()
], JbCarousel.prototype, "_previousDisabled", 2);
__decorateClass([
  e("slot")
], JbCarousel.prototype, "_slot", 2);
__decorateClass([
  e(".swiper")
], JbCarousel.prototype, "_swiper_element", 2);
__decorateClass([
  e(".swiper-wrapper")
], JbCarousel.prototype, "_swiper_wrapper", 2);
JbCarousel = __decorateClass([
  customElement("jb-carousel")
], JbCarousel);

export {
  JbCarousel
};
